<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './SettingsList'
import Editor from './SettingsEditor'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/settings/list'
    },
    {
      path: "new",
      name: "New setting",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Edit setting"
      }
    },
    {
      path: "edit/:id",
      name: "Edit setting",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "list",
      name: "Settings list",
      component: List
    }
  ],
}
</script>
